import { render, staticRenderFns } from "./page-index-brands-content.vue?vue&type=template&id=4538cf20&"
import script from "./page-index-brands-content.vue?vue&type=script&lang=ts&"
export * from "./page-index-brands-content.vue?vue&type=script&lang=ts&"
import style0 from "./page-index-brands-content.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports